import React, { useState } from 'react';
import { 
  FiDownload, 
  FiDollarSign, 
  FiPieChart, 
  FiTrendingUp, 
  FiArrowUp, 
  FiArrowDown,
  FiFileText 
} from 'react-icons/fi';

const FinancialMonitoring = () => {
  const [filterYear, setFilterYear] = useState('2025-2026');

  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc'
  };

  const financialData = [
    { id: 1, gp: 'इनाम धामणी', demand: 2500000, recovery: 2200000, balance: 300000, usage: 92 },
    { id: 2, gp: 'बेडग', demand: 1800000, recovery: 1500000, balance: 300000, usage: 85 },
    { id: 3, gp: 'आरग', demand: 2000000, recovery: 1200000, balance: 800000, usage: 60 },
    { id: 4, gp: 'म्हैसाळ', demand: 1500000, recovery: 1000000, balance: 500000, usage: 75 },
    { id: 5, gp: 'मालगाव', demand: 1200000, recovery: 1100000, balance: 100000, usage: 88 }
  ];

  const StatCard = ({ title, value, subtext, icon, trend, color }) => (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-gray-500 text-sm font-medium">{title}</p>
          <h3 className="text-2xl font-bold mt-1 text-gray-800">{value}</h3>
        </div>
        <div className={`p-3 rounded-lg`} style={{ backgroundColor: `${color}15`, color: color }}>
          {icon}
        </div>
      </div>
      <div className="flex items-center text-sm">
        {trend === 'up' ? (
          <span className="text-green-600 flex items-center font-medium"><FiArrowUp className="mr-1" /> +१२%</span>
        ) : (
          <span className="text-red-600 flex items-center font-medium"><FiArrowDown className="mr-1" /> -५%</span>
        )}
        <span className="text-gray-400 ml-2">{subtext}</span>
      </div>
    </div>
  );

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="flex flex-col md:flex-row justify-between items-center mb-8">
        <div>
          <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>आर्थिक निरीक्षण</h1>
          <p className="text-gray-600 text-sm">आर्थिक वर्ष {filterYear} चा सरांश आणि विश्लेषण</p>
        </div>
        <div className="flex gap-3 mt-4 md:mt-0">
          <select 
            className="p-2 border rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
            value={filterYear}
            onChange={(e) => setFilterYear(e.target.value)}
          >
            <option>2025-2026</option>
            <option>2024-2025</option>
          </select>
          <button className="flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg shadow-sm hover:bg-gray-50 font-medium">
            <FiDownload className="mr-2" /> अहवाल (PDF)
          </button>
        </div>
      </div>

      {/* Top Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-8">
        <StatCard 
          title="एकूण कर मागणी" 
          value="₹२ कोटी ५० लाख" 
          subtext="मागील महिन्यापेक्षा" 
          icon={<FiFileText size={24} />} 
          trend="up"
          color="#3b82f6"
        />
        <StatCard 
          title="एकूण वसुली" 
          value="₹१ कोटी ८० लाख" 
          subtext="मागील महिन्यापेक्षा" 
          icon={<FiDollarSign size={24} />} 
          trend="up"
          color="#10b981"
        />
        <StatCard 
          title="उर्वरित शिल्लक" 
          value="₹७० लाख" 
          subtext="वसुली बाकी" 
          icon={<FiPieChart size={24} />} 
          trend="down"
          color="#f59e0b"
        />
         <StatCard 
          title="निधी वापर" 
          value="७८%" 
          subtext="सरासरी वापर" 
          icon={<FiTrendingUp size={24} />} 
          trend="up"
          color="#8b5cf6"
        />
      </div>

      {/* Charts Section Placeholder */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <h3 className="font-bold text-gray-800 mb-6">मासिक कर वसुली विश्लेषण</h3>
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center border border-dashed border-gray-300">
             <p className="text-gray-500">येथे बार चार्ट दर्शविला जाईल (Bar Chart)</p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <h3 className="font-bold text-gray-800 mb-6">निधी वापर (योजना निहाय)</h3>
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center border border-dashed border-gray-300">
             <p className="text-gray-500">येथे पाय चार्ट दर्शविला जाईल (Pie Chart)</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6 border-b border-gray-100 flex justify-between items-center">
          <h3 className="font-bold text-gray-800">ग्रामपंचायत निहाय आर्थिक स्थिती</h3>
          <button className="text-teal-700 text-sm font-medium hover:underline">सर्व पहा</button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 text-gray-700 text-sm">
                <th className="p-4 font-semibold border-b">ग्रामपंचायत</th>
                <th className="p-4 font-semibold border-b text-right">कर मागणी (₹)</th>
                <th className="p-4 font-semibold border-b text-right">वसुली (₹)</th>
                <th className="p-4 font-semibold border-b text-right">शिल्लक (₹)</th>
                <th className="p-4 font-semibold border-b text-center">निधी वापर (%)</th>
                <th className="p-4 font-semibold border-b text-center">स्थिती</th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              {financialData.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  <td className="p-4 font-medium text-gray-800">{row.gp}</td>
                  <td className="p-4 text-right font-mono">{row.demand.toLocaleString('en-IN')}</td>
                  <td className="p-4 text-right font-mono text-green-600">{row.recovery.toLocaleString('en-IN')}</td>
                  <td className="p-4 text-right font-mono text-red-600">{row.balance.toLocaleString('en-IN')}</td>
                  <td className="p-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                       <span className="text-xs font-bold w-8">{row.usage}%</span>
                       <div className="w-20 bg-gray-200 rounded-full h-1.5 overflow-hidden">
                          <div 
                            className={`h-full rounded-full ${row.usage > 75 ? 'bg-green-500' : row.usage > 50 ? 'bg-yellow-500' : 'bg-red-500'}`} 
                            style={{ width: `${row.usage}%` }}
                          ></div>
                       </div>
                    </div>
                  </td>
                  <td className="p-4 text-center">
                    <span className={`px-2 py-1 rounded text-xs font-semibold ${
                      row.usage > 70 ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {row.usage > 70 ? 'उत्तम' : 'मध्यम'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FinancialMonitoring;
